import { useEffect, useState } from "react";
import { fetchBooks, createCheckout } from "@/lib/api";
import { BookOpen, ShoppingCart, FileText } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";

export default function Books() {
  const [books, setBooks] = useState([]);
  const { user } = useAuth() || {};
  const nav = useNavigate();

  useEffect(() => { fetchBooks().then(setBooks); }, []);

  const buy = async (book) => {
    if (!user) { toast.error("Please sign in first"); nav("/login"); return; }
    if (!book.stripe_lookup_key) { toast.error("This book isn't available for purchase yet."); return; }
    try {
      const r = await createCheckout(book.stripe_lookup_key, { kind: "book", book_id: book.id, book_title: book.title });
      window.location.href = r.checkout_url;
    } catch (e) { toast.error("Checkout failed"); }
  };

  return (
    <div className="pt-16" data-testid="books-page">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-10">
        <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-2 flex items-center gap-2"><BookOpen className="w-3 h-3"/>Featured Series</p>
        <h1 className="font-heading text-4xl md:text-6xl font-bold mb-3 leading-none">The VOT Living Book Series</h1>
        <p className="text-white/60 max-w-2xl mb-10">A curated collection of devotional and theological works. Read a preview PDF or purchase to support VOT Living.</p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {books.map(b => (
            <div key={b.id} className="content-card card-shine rounded-2xl overflow-hidden border border-white/10 bg-[#0A0A0E]" data-testid={`book-card-${b.id}`}>
              <div className="aspect-[2/3] overflow-hidden bg-black"><img src={b.cover_url} alt="" className="w-full h-full object-cover" /></div>
              <div className="p-4">
                <p className="text-[10px] text-[#D4AF37] tracking-widest uppercase">{b.tags?.[0] || "Volume"}</p>
                <h3 className="font-heading text-lg font-semibold text-white leading-tight mt-1 line-clamp-2">{b.title}</h3>
                <p className="text-xs text-white/50 mt-1">by {b.author}</p>
                <p className="text-[11px] text-white/40 mt-1">{b.year}</p>
                <p className="text-sm text-white/70 mt-3 line-clamp-3">{b.description}</p>
                <div className="mt-4 flex flex-col gap-2">
                  <button onClick={() => buy(b)} className="w-full btn-gold rounded-full text-sm py-2 flex items-center justify-center gap-2" data-testid={`buy-book-${b.id}`}>
                    <ShoppingCart className="w-4 h-4"/>Buy Now
                  </button>
                  {b.pdf_url && (
                    <a href={b.pdf_url} target="_blank" rel="noopener noreferrer" className="w-full btn-ghost rounded-full text-sm py-2 flex items-center justify-center gap-2" data-testid={`pdf-book-${b.id}`}>
                      <FileText className="w-4 h-4"/>Read PDF
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
